var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "button"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.98249 14.3567C10.5958 14.6412 11.2794 14.8 12 14.8C14.651 14.8 16.8 12.651 16.8 10C16.8 7.34903 14.651 5.2 12 5.2C9.34903 5.2 7.2 7.34903 7.2 10C7.2 11.4989 8.09596 13.0824 8.96346 13.7176C9.83095 14.3529 9.98524 14.3529 9.98524 14.3529C9.98524 14.3529 9.36913 14.0722 9.98249 14.3567ZM9.26575 15.3422C10.0857 15.7627 11.0151 16 12 16C15.3137 16 18 13.3137 18 10C18 6.68629 15.3137 4 12 4C8.68629 4 6 6.68629 6 10C6 11.8979 6.88118 13.59 8.25672 14.6894L5.01476 19.1471L5.98524 19.8529L9.26575 15.3422Z",
    fill: "#141414"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchRight);
export default __webpack_public_path__ + "static/media/SearchRight.fa38781e73e435b674244cd65116a453.svg";
export { ForwardRef as ReactComponent };